import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from '../../../actions'

import Select from 'react-select'

/**
 * Componente LanguageSelector per selezionare la lingua dell'applicazione.
 *
 * Questo componente rende un menu a discesa per la selezione della lingua utilizzando 'react-select'.
 * Consente agli utenti di passare tra le lingue disponibili, aggiornando lo stato dell'applicazione e memorizzando la lingua selezionata nel local storage.
 *
 * @param {boolean} login - Se vero, adatta lo stile per il contesto di login.
 */

export default function LanguageSelector({ login }) {
  const dispatch = useDispatch()
  const lang = useSelector((state) => state.language.language)

  const options = [
    { value: 'it', label: 'Italiano', flag: '/languages/lang-it-it.svg' },
    { value: 'en', label: 'English', flag: '/languages/lang-en-us.svg' }
  ]

  const [selectedLanguage, setSelectedLanguage] = useState(
    options.find((option) => option.value === lang) || options[0]
  )

  useEffect(() => {
    localStorage.setItem('language', lang)
  }, [lang])

  /**
   * Gestisce il click su un elemento del menu a discesa delle lingue.
   *
   * Aggiorna lo stato locale della lingua selezionata e chiama l'azione per cambiare la lingua nello stato dell'applicazione.
   *
   * @param {object} language - Elemento selezionato del menu a discesa, contiene la proprietà value con il valore della lingua.
   */
  const handleLanguageClick = (language) => {
    setSelectedLanguage(language)
    dispatch(actions.changeLanguage(language.value))
  }

  /**
   * Funzione per formattare l'etichetta delle opzioni del menu a discesa delle lingue.
   *
   * Restituisce un JSX che include l'immagine della bandiera e il testo corrispondente
   * alla lingua selezionata. Se login == true, non viene visualizzato il testo.
   *
   * @param {{ label: string, flag: string }} option - Oggetto con le proprietà label e flag.
   */
  const formatOptionLabel = ({ label, flag }) => {
    return (
      <div className="d-flex align-items-center">
        <img className={login ? '' : 'me-2'} src={flag} alt={label} />
        {!login && <span>{label}</span>}
      </div>
    )
  }

  return (
    <div className="d-flex align-items-center">
      <Select
        className="language-select"
        classNamePrefix="language-select"
        defaultValue={selectedLanguage}
        isSearchable={false}
        formatOptionLabel={formatOptionLabel}
        options={options}
        onChange={handleLanguageClick}
      />
    </div>
  )
}
